<template>
  <v-container class="portfolio" style="height: 100%;">
    <v-slide-x-reverse-transition mode="out-in">
      <v-row align="center" justify="center" style="height: 100%">
        <v-hover v-for="(item, n) in pages" :key="n" v-slot:default="{ hover }">
          <transition >
            <v-card
              class="d-flex flex-column align-center justify-center pa-5 ma-5 page-tile"
              outlined
              flat
              :width="hover? 260 : 225"
              :height="hover? 275 : 240"
              style="border-width: 5px;"
              @click="goto(item.url)"
            >
              <div class="ma-3"><v-icon color="primary" size="90">{{ item.icon }}</v-icon></div>
              <p class="display-1">{{ item.text }}</p>
            </v-card>
          </transition>
        </v-hover>
      </v-row>
    </v-slide-x-reverse-transition>
  </v-container>
</template>

<script>

export default {
  name: 'home',
  data: () => ({
    pages: [
      {
        icon: 'mdi-file-code-outline',
        text: 'portfolio',
        url: '/portfolio'
      },
      {
        icon: 'mdi-account-details',
        text: 'skills',
        url: '/skills'
      }
    ]
  }),
  methods: {
    goto (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style scoped>
  .page-tile {
    transition: .15s;
  }
</style>
